<div *appIsBlv>
  @if (tierarztSprache(); as tierarztSprache) {
    <div class="mb-15" [innerText]="tierarztSprache"></div>
  }

  <div class="btn-group mb-15" role="group">
    <button type="button" class="btn" [class]="sprache() === 'DE' ? 'btn-primary' : 'btn-default'" (click)="setSprache('DE')">{{ 'global.sprache.de' | translate }}</button>
    <button type="button" class="btn" [class]="sprache() === 'FR' ? 'btn-primary' : 'btn-default'" (click)="setSprache('FR')">{{ 'global.sprache.fr' | translate }}</button>
    <button type="button" class="btn" [class]="sprache() === 'IT' ? 'btn-primary' : 'btn-default'" (click)="setSprache('IT')">{{ 'global.sprache.it' | translate }}</button>
  </div>

  <div class="mb-15" [innerText]="label | translate">{{ 'meldung.view.deaktivieren.grund.label' | translate }}</div>
  @for (grund of gruende(); track grund.id) {
    <div (click)="setGrund(grund)" class="btn-link cursor-pointer">{{ grund.bezeichnung }}</div>
  }
</div>

<textarea autocomplete="off" aria-required="true"
          class="form-control textarea form_field form_field_textarea mt-15"
          rows="4" [(ngModel)]="kommentar"></textarea>

@if (error(); as error) {
  <div class="swal2-validation-message" [innerText]="error"></div>
}

<button class="btn btn-default mt-15" (click)="cancel()">{{ "global.cancel" | translate }}</button>
@if (pendingRequest()) {
  <button class="btn btn-primary mt-15 ml-15" disabled>
    <i class="fa fa-play fa-fw fa-spinner fa-pulse"></i>
  </button>
} @else {
  <button class="btn btn-primary mt-15 ml-15" (click)="save()">{{ "global.ok" | translate }}</button>
}
